import functions from "./functions";

$(() => {
    searchMobile.init();
});

function printDatesLabel(selectedDates, instance) {

    const language = functions.getLang();

    const translations = {
        'hr': {
            'please_select_dates': 'Molimo odaberite datume u kalendaru. <br />Datum prijave i odjave.',
            'check_in': 'Prijava',
            'check_out': 'Odjava',
            'select_on_calendar': 'Odaberi u kalendaru',
        },
        'en': {
            'please_select_dates': 'Please select dates on calendar. <br />Check in and check out date.',
            'check_in': 'Check in',
            'check_out': 'Check out',
            'select_on_calendar': 'Select on calendar',
        },
        'de': {
            'please_select_dates': 'Bitte wählen Sie die gewünschten Daten im Kalender aus. <br />An- und Abreisedatum.',
            'check_in': 'Einchecken',
            'check_out': 'Abreisen',
            'select_on_calendar': 'Im Kalender auswählen',
        }
    };

    let output = translations[language]['please_select_dates']; //`Please select dates on calendar. <br />Check in and check out date.`;

    if (selectedDates.length) {
        let dateFrom = selectedDates[0];
        let dateTo = selectedDates[1];
    
        //let dateFromFormat = dateFrom ? 'Check in: ' + instance.formatDate(dateFrom, "d.m.Y.") : 'Select on calendar';
        //let dateToFormat = 'Check out: ' + (dateTo ? instance.formatDate(dateTo, "d.m.Y.") : 'Select on calendar');

        let dateFromFormat = dateFrom ? translations[language]['check_in'] + ': ' + instance.formatDate(dateFrom, "d.m.Y.") : translations[language]['select_on_calendar'];
        let dateToFormat = translations[language]['check_out'] + ': ' + (dateTo ? instance.formatDate(dateTo, "d.m.Y.") : translations[language]['select_on_calendar']);
        output = `${dateFromFormat} <br />${dateToFormat}`;
    }

    $('.select-dates-label').html(output);
}

const searchMobile = {
    $modal: $('#listSearchModal'),
    $destinationTab: $('#destination-tab'),
    $periodTab: $('#period-tab'),
    $guestsTab: $('#guests-tab'),

    $datepicker: $('.search-datepicker'),
    $currentStepValue: $('.current-step-value'),

    $searchForm: $('.search-form'),

    guideInit: null,
    calendarInit: null,

    guideInstance: null,
    datepickerInstance: null,
    guestsInstance: null,

    params: {},

    init() {

        this.params = functions.getUrlData(true);
        this.splitDates(this.params);

        this.initCalendar();

        if(! this.$modal.length) return;

        $('.switch-menu').on('click', e => {

            const hideSearch = ! this.$searchForm.hasClass('hide-search');

            this.$searchForm.toggleClass('hide-search', hideSearch);
            $('.header-list-map .collapse').toggleClass('show', hideSearch);
        });

        this.guideInstance = $('.form-guide').length ? $('.form-guide')[0]._instance : null;
        this.datepickerInstance = this.$datepicker.length ? this.$datepicker[0]._flatpickr : null;
        this.guestsInstance = $('.simple-guests').length ? $('.simple-guests')[0]._simpleGuests : null;
        setTimeout(() => this.setBarValues(), 2000);

        functions.isMobile() && this.$modal.on('shown.bs.modal', e => setTimeout(() => {
            const $relatedTarget = $(e.relatedTarget);
            const tabId = $relatedTarget.attr('data-tabId');

            switch (tabId) {
                case 'period-tab':
                    this.$periodTab.tab('show');
                    break;
                case 'guests-tab':
                    this.$guestsTab.tab('show');
                    break;
                default:
                    this.$destinationTab.tab('show');
                    break;
            }

            //this.$destinationTab.tab('show');
        }));
        functions.isMobile() && this.$destinationTab.on('shown.bs.tab', e => this.showGuide());
        functions.isMobile() && this.$periodTab.on('shown.bs.tab', e => this.showCalendar());
        functions.isMobile() && this.$guestsTab.on('shown.bs.tab', e => this.showGuests());
        
        let setGuideStep = null;
        functions.isMobile() && this.guideInstance && this.guideInstance.$input.on('change', e => {
            //! setGuideStep && $(e.currentTarget).val() && this.nextStep('next');
            setGuideStep = true;
        });

        functions.isMobile() && $('#listSearchModal [name="dates"]').on('change', e => $(e.currentTarget).val() !== '' && this.nextStep('next'));
        functions.isMobile() && $('#listSearchModal [name="guests"]').on('change', e => $(e.currentTarget).val() !== '' && this.nextStep('next'));

        $('#listSearchModal [data-step]').on('click', e => {
            const step = $(e.currentTarget).attr('data-step');
            this.nextStep(step);
        });

        $('.search-mobile-submit').on('click', e => {
            $('.search-form').submit();
            this.setBarValues();
            this.$modal.modal('hide');
        });

        this.$currentStepValue.on('click', '[data-clear]', e => {
            const $target = $(e.currentTarget);
            const name = $target.attr('data-clear');
            const $field = $('[name="' + name + '"]');

            switch(name) {
                case 'ms':
                    $field.val('').trigger('change');
                    break;
                case 'dates':
                    this.datepickerInstance.clear();
                    $field.trigger('change');
                    break;
                case 'guests':
                    $field.val('0,0,0').trigger('change');
                    break;
                default:
                    $field.val('').trigger('change');
                    break;
            }

            this.$currentStepValue.empty();
        });

        $(window).on('hashchange', () => {
            functions.isMobile() && this.setBarValues();
        });
    },
    splitDates(params) {
        if(params.dates)
        {
            let val = params.dates.split(' - ');
            params.dateFrom  = val[0];
            params.dateTo    = val[1];
            params.dates = null;
        }
        else
        {
            return;
        }
        
    },
    nextStep(direction) {
        const $active = $('#listSearchModal .nav-link.active');

        const $prevOrNextSibling = direction == 'prev' ? $active.parent('.nav-item').prev() : $active.parent('.nav-item').next();

        if($prevOrNextSibling.length) {
            $prevOrNextSibling.find('.nav-link').tab('show');
        } else {
            this.$modal.modal('hide');
        }

        const $activeTab = $('#listSearchModal .nav-link.active');
        const activeTabId = $activeTab.attr('id');

        const isTabDestination = activeTabId == 'destination-tab';
        this.guideInstance[isTabDestination ? 'show' : 'hide']();

        this.showNextOrSearch();
    },
    showGuide() {
        this.guideInstance.show();

        const value = this.guideInstance.$input.val();
        let html = value ? `${ $('.form-guide')[0].innerHTML }<i class="ms-clear fa-light fa-xmark" data-clear="ms"></i>` : '';
        this.$currentStepValue.html(html);

        this.showNextOrSearch();
    },
    showCalendar() {
        this.initCalendar();

        const value = this.datepickerInstance.altInput.value;

        let html = value ? `${ value }<i class="fa-light fa-xmark" data-clear="dates"></i>` : '';

        this.$currentStepValue.html(html);

        this.showNextOrSearch();
    },
    initCalendar() {
        if(! this.calendarInit) {
            this.$datepicker.flatpickr({
                mode: "range",
                inline: functions.isMobile() ? true : false,
                showMonths: functions.isMobile() ? 1 : 2,
                altInput: true,
                wrap: functions.isMobile() ? false : true,
                altFormat: "j.m.Y",
                dateFormat: "Y-m-d",
                defaultDate: $('#listSearchModal [name="dates"]').val() || [this.params.dateFrom, this.params.dateTo],
                minDate: 'today',
                disableMobile: true,
                prevArrow: '<i class="fa-light fa-arrow-circle-left fa-fw"></i>',
                nextArrow: '<i class="fa-light fa-arrow-circle-right fa-fw"></i>',
                locale: {
                    rangeSeparator: ' - '
                },
                onReady: function (selectedDates, dateStr, instance) {
                    if(selectedDates.length == 2) {
                        $(instance.altInput).val(instance.formatDate(selectedDates[0], "d.m.") + instance.config.locale.rangeSeparator + instance.formatDate(selectedDates[1], "d.m."));
                    }
                    printDatesLabel(selectedDates, instance);
                },
                onChange: function (selectedDates, dateStr, instance) {

                    $('#listSearchModal [name="dates"]').val(dateStr);
                    selectedDates[1] && $('#listSearchModal [name="dates"]').trigger('change');

                    if(selectedDates.length == 2) {
                        $(instance.altInput).val(instance.formatDate(selectedDates[0], "d.m.") + instance.config.locale.rangeSeparator + instance.formatDate(selectedDates[1], "d.m."));
                    }

                    printDatesLabel(selectedDates, instance);
                },
            });
            // to style clear toggler
            this.$datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
        }
        this.calendarInit = true;
    },
    showGuests() {
        $('.simple-guests').siblings('.dropdown-menu').addClass('show');
        const value =  $('.simple-guests')[0]._simpleGuests.currentValue.startsWith('0') ? '' : $('.simple-guests-value')[0].innerHTML;
        let html = value ? `${ value }<i class="fa-light fa-xmark" data-clear="guests"></i>` : '';

        this.$currentStepValue.html(html);

        this.showNextOrSearch();
    },
    showNextOrSearch() {
        const $activeTab = $('#listSearchModal .nav-link.active');
        const activeTabId = $activeTab.attr('id');

        if (activeTabId == 'guests-tab') {
            $('.btn-next').addClass('d-none');
            $('.cta-search').removeClass('d-none');
        } else {
            $('.cta-search').addClass('d-none');
            $('.btn-next').removeClass('d-none');
        }
    },
    setBarValues() {
        $('.bar-destination-value').text(this.guideInstance?.selectedItem?.text || $('.bar-destination-value').attr('data-placeholder'));
        $('.bar-period-value').text(this.datepickerInstance?.altInput?.value || $('.bar-period-value').attr('data-placeholder'));
        //$('.bar-guests-value').text($('.simple-guests')[0]._simpleGuests.currentValue.startsWith('0') ? $('.bar-guests-value').attr('data-placeholder') : $('.simple-guests-value')[0].innerHTML);

        let guestValue = $('#listSearchModal [name="guests"]').val(); // $('.simple-guests')[0]._simpleGuests.currentValue;
        let isGuests = guestValue ? parseInt(guestValue[0]) : 0;
        let guestsOutput = ``;

        /*let guestsText = isGuests 
            ? $('.simple-guests-value')[0].innerHTML
            : $('.bar-guests-value').attr('data-placeholder');*/

        if (isGuests) {
            guestsOutput = this.guestsInstance.adults;

            if (this.guestsInstance.children) {
                guestsOutput += `<i class="fa-solid fa-child-reaching ms-2 me-2"></i>${this.guestsInstance.children}`;
            }
            if (this.guestsInstance.pets) {
                guestsOutput += `<i class="fa-solid fa-paw ms-2 me-2"></i>${this.guestsInstance.pets}`;
            }
        } else {
            guestsOutput = $('.bar-guests-value').attr('data-placeholder');
        }

        //$('.bar-guests-value').text(guestsText);
        $('.bar-guests-value').html(guestsOutput);
    },
};